import React from 'react';
import PropTypes from 'prop-types';
import s from './Quotes.scss';

class Quotes extends React.PureComponent {
  getQuotesHtmlForPrime() {
    // const s = this.props.styleObj;
    const returnHtml = (
      <div className={`${s.blockquote}`}>
        {this.props.imageid && (
          <div className={s.authorimg}>
            <img
              src={`https://static.toiimg.com/photo/${this.props.imageid}.cms`}
              alt=""
            />
          </div>
        )}
        <p>{this.props.value}</p>
        <div className={`${s.author_name}`}>
          {this.props.author || this.props.au}
        </div>
      </div>
    );

    return returnHtml;
  }

  getQuotesHtmlForNonPrime() {
    // const s = this.props.styleObj;
    const author = this.props.author || this.props.au;
    const authornameLower = author ? author.toLowerCase() : '';
    const isTimeView =
      authornameLower === 'timesview' || authornameLower === 'times view';
    const returnHtml = (
      <div
        className={`${s.blockquote} ${isTimeView ? s.timesview : ''} ${this
          .props.tags || ''} ${this.props.isNIC ? s.nic : ''}`}
      >
        {isTimeView && (
          <div className={`${s.author_name}`}>
            {author}
            <p>{this.props.value}</p>
            <small />
          </div>
        )}
        {!isTimeView && (
          <>
            <p>{this.props.value}</p>
            <div className={`${s.author_name}`}>
              {author}
              <small />
            </div>
          </>
        )}
      </div>
    );

    return returnHtml;
  }

  render() {
    const returnHtml = this.props.prime
      ? this.getQuotesHtmlForPrime()
      : this.getQuotesHtmlForNonPrime();

    return returnHtml;
  }
}

Quotes.propTypes = {
  author: PropTypes.string.isRequired,
  imageid: PropTypes.string,
  value: PropTypes.string.isRequired,
  isNIC: PropTypes.bool,
  prime: PropTypes.bool,
  tags: PropTypes.string,
  au: PropTypes.string,
};

Quotes.defaultProps = {
  imageid: '',
  prime: false,
  isNIC: false,
  tags: '',
  au: '',
};

export default Quotes;
